import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53775f7a")

_pushScopeId("data-v-53775f7a")
const _hoisted_1 = { style: {"width":"100%","height":"100%"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("iframe", {
      src: _ctx.graph,
      ref: "iframe",
      width: "100%",
      scrolling: "auto",
      frameborder: "no",
      height: _ctx.height
    }, null, 8, ["src", "height"])
  ]))
})